// extracted by mini-css-extract-plugin
export default {"inStockIndicator":"style--inStockIndicator--96aa5b","critical":"style--critical--9cd3d1","runningLow":"style--runningLow--1ad9af","sufficient":"style--sufficient--71a039"};